module.exports = __webpack_public_path__ + "media/images/Big-Short-188a6b1b7658d69e9f625ac08cf65458.svg";